// extracted by css-extract-rspack-plugin
export default {"singleItem":"TaskSwitcher-module__singleItem__BEQtr"};